import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminRoute = ({ component: Component }) => {
  const { auth } = useAuth();

  return auth.token && auth.role === 'admin' ? <Component /> : <Navigate to="/login" />;
};

export default AdminRoute;
